import { useState } from "react";
import "./index.less";
import { Select, Button, Upload, message } from "antd";
import type { UploadProps } from "antd";
const { Dragger } = Upload;
const Airdrop = () => {
  const [seleted, setSelected] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const tokens = [
    { value: "btc", label: "BTC", icon: "/icon/btc.svg" },
    { value: "eth", label: "ETH", icon: "/icon/btc.svg" },
    { value: "bnb", label: "BNB", icon: "/icon/btc.svg" },
  ];

  const props: UploadProps = {
    name: "file",
    multiple: true,
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  return (
    <div className="airdrop-layout">
      <div className="airdrop-header">
        <div className="airdrop-title">Batch Airdrop</div>
        <p className="airdrop-desc">
          Sending tokens to multiple addresses in batches
        </p>
      </div>
      <div className="airdrop-content">
        <Select
          size="large"
          placeholder="Select the token you want to airdrop"
          rootClassName="token-selector"
          className={seleted ? "token-selector-selected" : ""}
          onChange={() => setSelected(true)}
          options={tokens}
        />
        <div className="airdrop-content-middle">
          <div className="airdrop-upload">
            <p className="airdrop-upload-title">CSV文件上传</p>
            <p className="airdrop-upload-desc">
              1.下载CSV模板并填写接受地址和数量
            </p>
          </div>
        </div>
        <div className="template-download">
          <span className="template-download-title">下载CSV模板</span>
          <Button size="large" rootClassName="template-download-btn">
            下载
          </Button>
        </div>
        <p className="upload-title">2.上传填写好的CSV文件</p>
        <div className="airdrop-upload-file">
          <Dragger {...props}>
            <img src="/icon/folder-upload.svg" alt="" />
            <p className="upload-text">
              拖放CSV文件到这里
              <br />
              或&emsp;
              <span className="highlight-text">Select a file</span>
            </p>
          </Dragger>
        </div>
        <div
          style={{ fontSize: "20px", color: "#fff", cursor: "pointer" }}
          onClick={() => setBtnDisabled(!btnDisabled)}
        >
          change btn disable
        </div>
        <Button
          rootClassName="airdrop-deploy-btn"
          disabled={btnDisabled}
          size="large"
          block
        >
          Deploy
        </Button>
      </div>
    </div>
  );
};
export default Airdrop;
